import ButtonIcon from '../../../components/buttons/ButtonIcon';
import TableIcon from '../../../components/icons/TableIcon';
import orientationIcon from '../../../assets/icon/page-rotate-icon.svg';
import backCardIcon from '../../../assets/icon/ic-back-card.svg';
import frontCardIcon from '../../../assets/icon/ic-front-card.svg';
import FunctionalityCanvasControls from '../Functionality/CanvasControls';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const CanvasControl = ({
    currentStage,
    cardWidth,
    cardHeight,
    setStageProperties,
    setCurrentStage,
}) => {
    const { toggleOrientation, handleButtonClick } = FunctionalityCanvasControls({
        currentStage,
        cardWidth,
        cardHeight,
        setStageProperties,
        setCurrentStage,
    });
    return (
        <div className='mb-4 text-center'>
            <ButtonIcon
                id='btn-cc-changeOrientation'
                onClick={toggleOrientation}
                Icon={() => (
                    <TableIcon>
                        <img className='mx-0 px-0 w-50' src={orientationIcon} alt='Orientation Icon' />
                    </TableIcon>
                )}
                disabled={false}
                iconProps='btn-icon-svg-12px icon-color-general-00'
                className='btn'
            />

            <ButtonIcon
                id='btn-cc-cardChange'
                onClick={handleButtonClick}
                Icon={() => (
                    <TableIcon>
                        <img
                            className='mx-0 px-0 w-50'
                            src={currentStage === 1 ? frontCardIcon : backCardIcon}
                            alt='Card Side Icon'
                        />
                    </TableIcon>
                )}
                disabled={false}
                iconProps='btn-icon-svg-12px icon-color-general-00'
                className='btn'
            />
        </div>
    );
};

export default CanvasControl;
